import React, { Component } from "react";
import Print_RaumBuchProduct from "./rb_Print_Product";
import RB_RoomArea from "./RB_RoomArea";
import RB_RoomAreaPrint from "./RB_RoomAreaPrint";
import jspdf from "jspdf";
import project from "../config";
import Spinner from "../components/spinner";
const projectLogo = require(`../assets/${project.assets}/img/projectLogo.png`);
// import { font } from "../js/BoBTextWeb-Regular-normal";

function appendScript(scriptAddress) {
	const script = document.createElement("script");
	script.src = scriptAddress;
	script.async = true;
	document.body.appendChild(script);
}

class RoomBook extends Component {
	state = {
		showSpinner: false
	};

	constructor(props) {
    super(props);
    this.savePdf = this.savePdf.bind(this);
  }

	savePdf() {
		this.setState({ showSpinner: true });
		let pdfOption = {
			orientation: "p",
			unit: "mm",
			format: [210, 297],
			// hotfixes: ["px_scaling"],
			// putOnlyUsedFonts: true,
			compress: true,
		};

		var doc = new jspdf(pdfOption);

		var that = this;
		doc.html(document.querySelector("#RoomBookPDF"), {
			callback: function (pdf) {
				that.setState({ showSpinner: false });
				pdf.save(`RaumBuch-${that.props.apiData.unitInfo.unitName}.pdf`);
			},
			x: 5,
			y: 5,
			// width: 790,
			// windowWidth: 790,
			width: 210,
			windowWidth: 800,
		});
	}

	render() {
		let { apiData, isShow, setHide, basePrice } = this.props;
		let roomAreaMarkUp;
		let roomAreaMarkUpPrint;
		let unitArea = 0;
		let unitName;
		let projectName;
		let priceBase = 0;
		let priceAdditional = 0;
		let priceReduction = 0;
		if (apiData) {
			roomAreaMarkUp = apiData.changeObj.map((arr, id) => (
				<RB_RoomArea key={id} data={arr} />
			));

			// --------------------------------------------- PDF Markup Generator ------------------------------------

			const roomsDataCopy = JSON.parse(JSON.stringify(apiData.changeObj));
			// console.log(roomsDataCopy);

			let pageItemsNumber = 5; // Items per page
			let pageItemsRemain = pageItemsNumber - 1;
			let pageItems = [];
			let section = {
				roomArea: 0,
				roomName: "",
				surcharge: 0,
				selectedChoice: [],
			};
			let pages = [];
			let pageNumber = 1;
			let areaTotalPrice = 0;

			while (roomsDataCopy.length > 0) {
				let currentRoomObjCount = roomsDataCopy[0].selectedChoice.length;

				if (pageItemsRemain >= currentRoomObjCount) {
					section.roomArea = roomsDataCopy[0].roomArea;
					section.roomName = roomsDataCopy[0].roomName;
					section.selectedChoice = roomsDataCopy[0].selectedChoice;

					if (areaTotalPrice == 0) {
						for (let z = 0; z < roomsDataCopy[0].selectedChoice.length; z++) {
							areaTotalPrice +=
								roomsDataCopy[0].selectedChoice[z].choice.surcharge;
						}
					}

					section.surcharge = areaTotalPrice;

					pageItems.push({ ...section });

					roomsDataCopy.shift();
					areaTotalPrice = 0;

					if (roomsDataCopy.length == 0) {
						pageItemsRemain = 0;
					} else {
						pageItemsRemain = pageItemsRemain - currentRoomObjCount;
					}
				} else {
					section.roomArea = roomsDataCopy[0].roomArea;
					section.roomName = roomsDataCopy[0].roomName;
					section.selectedChoice = [
						...roomsDataCopy[0].selectedChoice.slice(0, pageItemsRemain),
					];

					for (let z = 0; z < roomsDataCopy[0].selectedChoice.length; z++) {
						areaTotalPrice +=
							roomsDataCopy[0].selectedChoice[z].choice.surcharge;
					}

					section.surcharge = areaTotalPrice;

					pageItems.push({ ...section });

					roomsDataCopy[0].selectedChoice.splice(0, pageItemsRemain);

					pageItemsRemain = 0;
				}
				if (pageItemsRemain == 0) {
					pageItems.push(pageNumber);
					pages.push(pageItems);

					pageNumber++;
					pageItemsRemain = pageItemsNumber;
					pageItems = [];
				}
			}

			roomAreaMarkUpPrint = pages.map((arr, id) => (
				<RB_RoomAreaPrint key={id} data={arr} pageNumber={pages.length} />
			));

			unitArea = apiData.unitInfo.unitArea;
			unitName = apiData.unitInfo.unitName;
			projectName = apiData.unitInfo.projectName;
			priceBase = basePrice;

			for (let i = 0; i < apiData.changeObj.length; i++) {
				for (let j = 0; j < apiData.changeObj[i].selectedChoice.length; j++) {
					priceAdditional +=
						apiData.changeObj[i].selectedChoice[j].choice.surcharge;
				}
			}
		}
		priceReduction = (priceBase + priceAdditional) * 0.03;
		priceReduction = Math.round(priceReduction * 100) / 100;

		let isShowClass = isShow === false ? "RBuch--hide" : "";
		return (
			<div className={"RBuchContainer " + isShowClass}>
				<div className="RBuchBG" onClick={() => setHide(false)}></div>
				<div className="RBuchWindow">
					<button onClick={() => setHide(false)} className="RBuch-mobileBack">
						X
					</button>
					<div className="RBuch-UpperSection">
						<div className="RBuch-Header">
							<div className="RBuch-HLeft">
								<img
									className="RBuch-HeaderLogo"
									src={projectLogo}
									alt="Project Logo"
								/>
								<span className="RBuch-RoomName">{unitName}</span>
								<span className="RBuch-ProjectName">{projectName}</span>
								<span className="RBuch-RoomSize">
									{unitArea.toLocaleString("de-DE", {
										maximumFractionDigits: 2,
									})}{" "}
									&#13217;
								</span>
							</div>
							<div className="RBuch-HMiddle"></div>
							<div className="RBuch-HRight">
								<div className="RBuch-PriceRow">
									<span>Grundpreis:</span>
									<span>
										{priceBase.toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceRow">
									<span>Aufpreis:</span>
									<span>
										{priceAdditional.toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceSum">
									<span>Summe</span>
									<span>
										{(priceBase + priceAdditional).toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceRow">
									<span>Ihr Preisnachlass 3%:</span>
									<span>
										{priceReduction.toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceRow">
									<span>Ihr Kaufpreis:</span>
									<span>
										{(priceBase + priceAdditional - priceReduction).toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
							</div>
						</div>
						{roomAreaMarkUp}
					</div>
					<div className="RBuch-LowerSection">
						<button onClick={() => setHide(false)}>Zurück</button>
						<button onClick={this.savePdf}>Download PDF</button>
					</div>
					<Spinner showSpinner={this.state.showSpinner} />
				</div>
				{/* --------------------------------- PDF SECTION --------------------------------- */}
				<div className="RBuchWindow--Print">
					<div id="RoomBookPDF" className="RBuch-UpperSection--Print">
						<div className="RBuch-Header-Print">
							<div className="RBuch-HLeft-Print">
								<img
									className="RBuch-HeaderLogo-Print"
									src={projectLogo}
									alt="Project Logo"
								/>
								<span className="RBuch-RoomName-Print">{unitName}</span>

								<span className="RBuch-RoomSize-Print">
									{unitArea.toLocaleString("de-DE", {
										maximumFractionDigits: 2,
									})}{" "}
									m2
								</span>
							</div>
							<div className="RBuch-HRight-Print">
								<div className="RBuch-PriceRow-Print">
									<span>Grundpreis:</span>
									<span>
										{priceBase.toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceRow-Print">
									<span>Aufpreis:</span>
									<span>
										{priceAdditional.toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceSum RBuch-PriceSum-Print">
									<span>Summe</span>
									<span>
										{(priceBase + priceAdditional).toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceRow-Print">
									<span>Ihr Preisnachlass 3%:</span>
									<span>
										{priceReduction.toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
								<div className="RBuch-PriceRow-Print">
									<span>Ihr Kaufpreis:</span>
									<span>
										{(priceBase + priceAdditional - priceReduction).toLocaleString("de-DE", {
											style: "currency",
											currency: "EUR",
											maximumFractionDigits: 2,
										})}
									</span>
								</div>
							</div>
						</div>

						{roomAreaMarkUpPrint}
					</div>
					<div className="RBuch-LowerSection RBuch-LowerSection--Print">
						<button onClick={() => setHide(false)}>Back</button>
						<button onClick={this.savePdf}>Download PDF</button>
					</div>
				</div>
			</div>
		);
	}
}

export default RoomBook;
